import { render, staticRenderFns } from "./OverviewTaxPayer.vue?vue&type=template&id=733f7017&scoped=true&"
import script from "./OverviewTaxPayer.vue?vue&type=script&lang=js&"
export * from "./OverviewTaxPayer.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTaxPayer.vue?vue&type=style&index=0&id=733f7017&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733f7017",
  null
  
)

export default component.exports